// extracted by mini-css-extract-plugin
module.exports = {"informationPanelRoot":"informationPanelRoot--04ce9"};